import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import isEmpty from 'lodash-es/isEmpty'

import { EMPTY_LIST } from '../../../constants/common'
import { useInlineNotifications } from '../../../hooks'
import { FormikForm } from '../../Formik'

import { DOC_FLOW_FORM_INITIAL_VALUES } from './DocFlowForm.constants'
import {
  getDocFlowFormCreationPayload,
  getDocFlowFormServerErrors,
  getInitialNotifications,
  getValidationSchema,
} from './DocFlowForm.utils'
import { FormFields } from './FormFields'

function DocFlowForm({
  FormContainer,
  containerProps,
  fieldsProps,
  getPayload = getDocFlowFormCreationPayload,
  initialValues,
  setModal,
  onCancel,
  onSubmit,
  onSuccess,
}) {
  const { t } = useTranslation()

  const [files, setFiles] = useState(EMPTY_LIST)

  const initialNotifications = getInitialNotifications()

  const { handleAddNotification, handleRemoveNotification, notifications } =
    useInlineNotifications({ initialNotifications })

  function handleSubmit(values, { setErrors, setSubmitting }) {
    const payload = getPayload({
      files,
      values,
    })

    onSubmit(payload)
      .then(({ data }) => {
        onSuccess?.(data)
      })
      .catch(({ response }) => {
        if (!isEmpty(response?.data)) {
          setSubmitting(false)
          setErrors(
            getDocFlowFormServerErrors({ data: response.data, t, values })
          )
        }
      })
  }

  return (
    <FormikForm
      Container={FormContainer}
      containerProps={containerProps}
      initialValues={{ ...DOC_FLOW_FORM_INITIAL_VALUES, ...initialValues }}
      validateOnBlur={false}
      validateOnChange={false}
      validationSchema={getValidationSchema}
      onSubmit={handleSubmit}
    >
      <FormFields
        {...fieldsProps}
        files={files}
        notifications={notifications}
        setFiles={setFiles}
        setModal={setModal}
        onCancel={onCancel}
        onRemoveNotification={handleRemoveNotification}
        onSetNotification={handleAddNotification}
      />
    </FormikForm>
  )
}

export default DocFlowForm
